
import { Form, Row, Col, Input, Card } from "antd";
import { useEffect, useState } from "react";
import { IDriverByIdResponse } from "../../../../types/driver";
import { UploadImage } from "../../../axios/imageUpload";
import { handleImageSize } from "../../../../utils/handleImageSize";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import eyeIcon from "../../../../assets/eyeIcon.svg";

type DocumentDetailsProps = {
  data?: IDriverByIdResponse;
  setAadharFrontImage?: any;
  setAadharBackImage?: any;
  setDrivingLicenceFrontImage?: any;
  setPanFrontImage?: any;
  documentDetailsResponse?: any;
  downloadDriverDocuments?: any;
  isDownloading?: boolean;
  onDownloadClick?: () => Promise<void>;
};

const imageUploaderStyle = {
  width: "12rem",
  height: "8rem",
};
export default function DocumentDetails(props: DocumentDetailsProps) {
  const [form] = Form.useForm();
  const [aadharError, setAadharError] = useState("");
  const [hoverAadhaarFront, setHoverAadhaarFront] = useState(false);
  const [hoverAadhaarBack, setHoverAadhaarBack] = useState(false);
  const [hoverPanCard, setHoverPanCard] = useState(false);
const [hoverDrivingLicenseFront, setHoverDrivingLicenseFront] = useState(false);
  const [hoverDrivingLicenseBack, setHoverDrivingLicenseBack] = useState(false);
  const [panError, setPanError] = useState("");
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const handlePreview = (imageUrl: string) => {
    setPreviewImage(imageUrl);
    setIsPreviewVisible(true);
  };
  const handleCancelPreview = () => {
    setIsPreviewVisible(false);
    setPreviewImage("");
  };
      
  const {
    data,
    setAadharFrontImage,
    setAadharBackImage,
    setDrivingLicenceFrontImage,
    setPanFrontImage,
    documentDetailsResponse,
  } = props;

  const [aadharFrontImg, setAadharFrontImg] = useState({
    fImage_file: '',
    fImage_preview: "",
  });
  const [aadharBackImg, setAadharBackImg] = useState({
    bImage_file: '',
    bImage_preview: "",
  });

const aadharFrontImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setAadharFrontImg({
              fImage_preview: image_as_base64,
              fImage_file: res.data,
            });
            setAadharFrontImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };

const aadharBackImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setAadharBackImg({
              bImage_preview: image_as_base64,
              bImage_file: res.data,
            });
            setAadharBackImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };

  const [panFrontImg, setPanFrontImg] = useState({
    fImage_file: '',
    fImage_preview: "",
  });

const panFrontImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setPanFrontImg({
              fImage_preview: image_as_base64,
              fImage_file: res.data,
            });
            setPanFrontImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };

  const [drivingLicenceFrontImg, setDrivingLicenceFrontImg] = useState({
    fImage_file: '',
    fImage_preview: "",
  });
  const [drivingLicenceBackImg, setDrivingLicenceBackImg] = useState({
    bImage_file: '',
    bImage_preview: "",
  });

const drivingLicenceFrontImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setDrivingLicenceFrontImg({
              fImage_preview: image_as_base64,
              fImage_file: res.data,
            });
            setDrivingLicenceFrontImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };

// const drivingLicenceBackImgHandler = async (e: any) => {
//     if (e.target.files && e.target.files.length > 0) {
//       const file = e.target.files[0];
  
//       const resultImage= await handleImageSize(file);

//       if(resultImage!==undefined){
//         const compressedFile:File=resultImage;
//         const image_as_base64 = URL.createObjectURL(compressedFile);
  
//         let fd = new FormData();
//         fd.append('image', compressedFile);

//         UploadImage(fd)
//           .then((res) => {
//             setDrivingLicenceBackImg({
//               bImage_preview: image_as_base64,
//               bImage_file: res.data,
//             });
//             setDrivingLicenceBackImage(res.data.url || res.data);
//           })
//           .catch((err) => {
//             console.log(err);
//           });
//         }
//     }
//   };

  const [formData, setFormData] = useState({
    aadhar: "",
    pan: "",
    drivingLicence: "",
  });

  const handleFieldChange = (fieldName: any, value: any) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
    let response = Object.values(formData).every(
      (value) => value.trim() !== ""
    );
    documentDetailsResponse?.(response);
  };
   const buttonStyle = (hovered: boolean) => ({
    backgroundColor: hovered ? "#4c9eff" : "#3e4685",
    color: "white",
    padding: "6px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "inline-block",
    transition: "background-color 0.3s ease",
  });
  const isValid_Aadhaar_Number = (e: any) => {
    handleFieldChange("aadhar", e.target.value);
    if (!/^[1-9][0-9]{11}$/.test(e.target.value)) {
      setAadharError("Invalid aadhar number");
    } else {
      setAadharError("");
    }
  };

  const isValidPanCardNo = (e: any) => {
    handleFieldChange("pan", e.target.value);
    if (/^[A-Za-z0-9]{10}$/.test(e.target.value)) {
      setPanError("");
    } else {
      setPanError("Invalid PAN number");
    }
  };
  const isValidLicenseNumber = (e: any) => {
    handleFieldChange("drivingLicence", e.target.value);
  };

  useEffect(() => {
    setAadharFrontImg({
      fImage_preview: `${data?.data?.documentList[0]?.cardFrontImage}`,
      fImage_file: `${data?.data?.documentList[0]?.cardFrontImage}`,
    });
    setAadharFrontImage(data?.data?.documentList[0]?.cardFrontImage);

    setAadharBackImg({
      bImage_file: `${data?.data?.documentList[0]?.cardBackImage}`,
      bImage_preview: `${data?.data?.documentList[0]?.cardBackImage}`,
    });
    setAadharBackImage(data?.data?.documentList[0]?.cardBackImage);

    setPanFrontImg({
      fImage_preview: `${data?.data?.documentList[2]?.cardFrontImage}`,
      fImage_file: `${data?.data?.documentList[2]?.cardFrontImage}`,
    });
    setPanFrontImage(data?.data?.documentList[2]?.cardFrontImage);

    setDrivingLicenceFrontImg({
      fImage_preview: `${data?.data?.documentList[1]?.cardFrontImage}`,
      fImage_file: `${data?.data?.documentList[1]?.cardFrontImage}`,
    });
    setDrivingLicenceFrontImage(data?.data?.documentList[1]?.cardFrontImage);

    setDrivingLicenceBackImg({
      bImage_file: `${data?.data?.documentList[1]?.cardBackImage}`,
      bImage_preview: `${data?.data?.documentList[1]?.cardBackImage}`,
    });
  }, [data]);

  return (
    <>
      <Form
        form={form}
        name="documentDetailForm"
        initialValues={{
          aadhaarNumber: data?.data.documentList[0]?.cardNumber,
          drivingNumber: data?.data.documentList[1]?.cardNumber,
          panNumber: data?.data.documentList[2]?.cardNumber,
        }}
      >
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <label>Aadhar</label>
            <div className="borderBoxPermit">
              <div>
                <Form.Item
                  name="aadhaarNumber"
                  style={{ marginBottom: 8 }}
                  rules={[
                    { required: true, message: "Aadhar number is required" },
                  ]}
                >
                  <Input.Password onChange={(e) => isValid_Aadhaar_Number(e)} />
                </Form.Item>
                {aadharError && <p style={{ color: "red" }}>{aadharError}</p>}

               <Row  style={{ marginTop: 10}}>
                  <Col span={12}>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
    <div style={{ position: "relative" }}>
      <img
        src={aadharFrontImg.fImage_preview}
        alt="Front Img"
        style={imageUploaderStyle}
      />
      <img
        src={eyeIcon}
        alt="Preview Icon"
        style={{
          position: "absolute",
          
          bottom: 8,
          right: 8,
          fontSize: "18px",
          background: "white",
          color: "black",
          borderRadius: "50%",
          padding: "4px",
          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
          cursor: "pointer",
          zIndex: 2,
          width: "24px",
          height: "24px",
        }}
        onClick={() => handlePreview(aadharFrontImg.fImage_preview)}
      />
    </div>

    <input
      id="aadhaarFrontImage"
      type="file"
      style={{ display: "none" }}
      onChange={aadharFrontImgHandler}
    />
    <label
      htmlFor="aadhaarFrontImage"
       style={buttonStyle(hoverAadhaarFront)}
          onMouseEnter={() => setHoverAadhaarFront(true)}
          onMouseLeave={() => setHoverAadhaarFront(false)}
    >
      Upload Front
    </label>
  </div>
</Col>

                  <Col span={12}>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
    <div style={{ position: "relative" }}>
      <img
        src={aadharBackImg.bImage_preview}
        alt="Front Img"
        style={imageUploaderStyle}
      />
      <img
        src={eyeIcon}
        alt="Preview Icon"
        style={{
          position: "absolute",
          
          bottom: 8,
          right: 8,
          fontSize: "18px",
          background: "white",
          color: "black",
          borderRadius: "50%",
          padding: "4px",
          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
          cursor: "pointer",
          zIndex: 2,
          width: "24px",
          height: "24px",
        }}
        onClick={() => handlePreview(aadharBackImg.bImage_preview)}
      />
    </div>

    <input
      id="aadhaarBackImage"
      type="file"
      style={{ display: "none" }}
      onChange={aadharBackImgHandler}
    />
    <label
      htmlFor="aadhaarBackImage"
       style={buttonStyle(hoverAadhaarBack)}
          onMouseEnter={() => setHoverAadhaarBack(true)}
          onMouseLeave={() => setHoverAadhaarBack(false)}
    >
      Upload Back
    </label>
  </div>
</Col>
                </Row>
              </div>
            </div>

            <label>PAN</label>
            <div className="borderBoxPermit">
              <Form.Item
                name="panNumber"
                style={{ marginBottom: 8 }} 
                rules={[{ required: true, message: "PAN number is required" }]}
              >
                <Input.Password onChange={(e) => isValidPanCardNo(e)} />
              </Form.Item>
              {panError && <p style={{ color: "red" }}>{panError}</p>}

              <Row style={{ marginTop: 10}} >
                <Col span={12}>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
    <div style={{ position: "relative" }}>
      <img
        src={panFrontImg.fImage_preview}
        alt="Front Img"
        style={imageUploaderStyle}
      />
      <img
        src={eyeIcon}
        alt="Preview Icon"
        style={{
          position: "absolute",
         
          bottom: 8,
          right: 8,
          fontSize: "18px",
          background: "white",
          color: "black",
          borderRadius: "50%",
          padding: "4px",
          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
          cursor: "pointer",
          zIndex: 2,
          width: "24px",
          height: "24px",
        }}
        onClick={() => handlePreview(panFrontImg.fImage_preview)}
      />
    </div>

    <input
      id="panFrontImage"
      type="file"
      style={{ display: "none" }}
      onChange={panFrontImgHandler}
    />
    <label
      htmlFor="panFrontImage"
       style={buttonStyle(hoverPanCard)}
          onMouseEnter={() => setHoverPanCard(true)}
          onMouseLeave={() => setHoverPanCard(false)}
    >
      Upload Front
    </label>
  </div>


                </Col>
                {/* <Col span={12}>
                  <Card>
                    <img
                      src={panBackImg.bImage_preview}
                      alt=" Back Img"
                      style={imageUploaderStyle}
                    />
                  </Card>
                  <input
                    type="file"
                    className="custom-backbtn"
                    name="backImage"
                    onChange={panBackImgHandler}
                  />
                </Col> */}
              </Row>
            </div>
          </Col>

          <Col span={12}>
            <label>Driving Licence</label>
            <div className="borderBoxPermit">
              <Form.Item
                name="drivingNumber"
                style={{marginBottom:10}}
                rules={[
                  {
                    required: true,
                    message: "Driving licence number is required",
                  },
                ]}
              >
                <Input.Password onChange={(e) => isValidLicenseNumber(e)} />
              </Form.Item>

              <Row style={{marginTop:10}}>
                <Col span={12}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                    <div style={{ position: "relative" }}>
                      <img
                        src={drivingLicenceFrontImg.fImage_preview}
                        alt="Front Img"
                        style={imageUploaderStyle}
                      />
                      <img
                        src={eyeIcon}
                        alt="Preview Icon"
                        style={{
                          position: "absolute",
                          bottom: 8,
                          right: 8,
                          fontSize: "18px",
                          background: "white",
                          color: "black",
                          borderRadius: "50%",
                          padding: "4px",
                          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                          cursor: "pointer",
                          zIndex: 2,
                          width: "24px",
                          height: "24px",
                        }}
                        onClick={() => handlePreview(drivingLicenceFrontImg.fImage_preview)}
                      />
                    </div>

                    <input
                      id="drivingLicenceFrontImage"
                      type="file"
                      style={{ display: "none" }}
                      onChange={drivingLicenceFrontImgHandler}
                    />
                    <label
                      htmlFor="drivingLicenceFrontImage"
                      style={buttonStyle(hoverDrivingLicenseFront)}
          onMouseEnter={() => setHoverDrivingLicenseFront(true)}
          onMouseLeave={() => setHoverDrivingLicenseFront(false)}
                    >
                      Upload Front
                    </label>
                  </div>
                </Col>
                {/* <Col span={12}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                    <div style={{ position: "relative" }}>
                      <img
                        src={drivingLicenceBackImg.bImage_preview}
                        alt="Back Img"
                        style={imageUploaderStyle}
                      />
                      <img
                        src={eyeIcon}
                        alt="Preview Icon"
                        style={{
                          position: "absolute",
                          bottom: 8,
                          right: 8,
                          fontSize: "18px",
                          background: "white",
                          color: "black",
                          borderRadius: "50%",
                          padding: "4px",
                          boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                          cursor: "pointer",
                          zIndex: 2,
                          width: "24px",
                          height: "24px",
                        }}
                        onClick={() => handlePreview(drivingLicenceBackImg.bImage_preview)}
                      />
                    </div>

                    <input
                      id="drivingLicenceBackImage"
                      type="file"
                      style={{ display: "none" }}
                      onChange={drivingLicenceBackImgHandler}
                    />
                    <label
                      htmlFor="drivingLicenceBackImage"
                      style={buttonStyle(hoverDrivingLicenseBack)}
                      onMouseEnter={() => setHoverDrivingLicenseBack(true)}
                      onMouseLeave={() => setHoverDrivingLicenseBack(false)}
                    >
                      Upload Back
                    </label>
                  </div>
                </Col> */}
              </Row>
            </div>
             {/* Download Documents Button */}
             <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center' }}>
                <button
                  onClick={props.onDownloadClick}
                  disabled={props.isDownloading}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    backgroundColor: 'transparent',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    cursor: props.isDownloading ? 'not-allowed' : 'pointer',
                    color: '#333',
                    fontSize: '14px',
                    transition: 'all 0.3s',
                    opacity: props.isDownloading ? 0.6 : 1,
                  }}
                  onMouseOver={(e) => {
                    if (!props.isDownloading) {
                      e.currentTarget.style.borderColor = '#1890ff';
                      e.currentTarget.style.color = '#1890ff';
                    }
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.borderColor = '#d9d9d9';
                    e.currentTarget.style.color = '#333';
                  }}
                >
                  <DownloadOutlined />
                  {props.isDownloading ? 'Downloading...' : 'Download All Documents'}
                </button>
              </div>
          </Col>
          <Modal
            visible={isPreviewVisible}
            footer={null}
            onCancel={handleCancelPreview}
            centered
            width={600}
          >
            <img
              alt="Document Preview"
              style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
              src={previewImage}
            />
          </Modal>
        </Row>
      </Form>
    </>
  );
}
